export var OrgParticipantRole;
(function (OrgParticipantRole) {
    OrgParticipantRole["OWNER"] = "GLOBAL_OrganizationOwner";
    OrgParticipantRole["ADMINISTRATOR"] = "GLOBAL_OrganizationAdmin";
    OrgParticipantRole["CREATOR"] = "GLOBAL_OrganizationCreator";
    OrgParticipantRole["READER"] = "GLOBAL_OrganizationReader";
    OrgParticipantRole["RESTRICTED_CREATOR"] = "GLOBAL_OrganizationRestrictedCreator";
    OrgParticipantRole["RESTRICTED_READER"] = "GLOBAL_OrganizationRestrictedReader";
})(OrgParticipantRole || (OrgParticipantRole = {}));
//# sourceMappingURL=OrgParticipantRoles.js.map